export type UserRole = 'user' | 'business' | 'charity' | 'admin' | 'super_admin';

export type BusinessRole = 'owner' | 'manager' | 'supervisor' | 'staff' | 'volunteer';
export type CharityRole = 'owner' | 'manager' | 'supervisor' | 'staff' | 'volunteer';
export type SuperAdminRole = 'super_admin';

export interface RolePermissions {
  canModifyBusinessDetails: boolean;
  canManageStaff: boolean;
  canViewBilling: boolean;
  canModifyBilling: boolean;
  canManageProducts: boolean;
  canViewProducts: boolean;
  canScanQR: boolean;
  canManageUsers: boolean;
  canManageEvents?: boolean;
  canExportReports?: boolean;
  isSuperAdmin?: boolean;
}

export const BUSINESS_ROLE_PERMISSIONS: Record<BusinessRole, RolePermissions> = {
  owner: {
    canModifyBusinessDetails: true,
    canManageStaff: true,
    canViewBilling: true,
    canModifyBilling: true,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: true,
    canExportReports: true,
  },
  manager: {
    canModifyBusinessDetails: true,
    canManageStaff: true,
    canViewBilling: true,
    canModifyBilling: true,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: true,
    canExportReports: true,
  },
  supervisor: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
  staff: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: false,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
  volunteer: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: false,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
};

export const CHARITY_ROLE_PERMISSIONS: Record<CharityRole, RolePermissions> = {
  owner: {
    canModifyBusinessDetails: true,
    canManageStaff: true,
    canViewBilling: true,
    canModifyBilling: true,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: true,
    canExportReports: true,
  },
  manager: {
    canModifyBusinessDetails: true,
    canManageStaff: true,
    canViewBilling: true,
    canModifyBilling: true,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: true,
    canExportReports: true,
  },
  supervisor: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: true,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
  staff: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: false,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
  volunteer: {
    canModifyBusinessDetails: false,
    canManageStaff: false,
    canViewBilling: false,
    canModifyBilling: false,
    canManageProducts: false,
    canViewProducts: true,
    canScanQR: true,
    canManageUsers: false,
    canExportReports: false,
  },
};

export const SUPER_ADMIN_PERMISSIONS: RolePermissions = {
  canModifyBusinessDetails: true,
  canManageStaff: true,
  canViewBilling: true,
  canModifyBilling: true,
  canManageProducts: true,
  canViewProducts: true,
  canScanQR: true,
  canManageUsers: true,
  canManageEvents: true,
  isSuperAdmin: true,
}; 